const c = {
  name: "CocktailMojito",
  dimensions: { width: 33, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 33.1 40" style="enable-background:new 0 0 33.1 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,19L21,19L21,19L21,19c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0.1-0.8,0.1c-0.6,0.1-1.5,0.2-2.4,0.4
			c-0.9,0.2-1.9,0.4-2.8,0.7c-0.8,0.3-1.7,0.7-2.3,1.2c-1.7,1.7-1.9,4.4-0.6,6.3l-1.5,1.5l1.4,1.4l1.5-1.5c1.9,1.3,4.6,1.1,6.3-0.6
			c0.6-0.6,1-1.4,1.2-2.3c0.3-0.9,0.5-1.8,0.7-2.7c0.2-0.9,0.3-1.8,0.4-2.4c0-0.3,0.1-0.6,0.1-0.8c0-0.1,0-0.2,0-0.2l0-0.1l0,0l0,0
			l0.1-1.2L21,19z M21.1,20l1,0.1C22.1,20.1,22.1,20.1,21.1,20z M21.1,20C21,19,21,19,21,19L21.1,20z M14.8,27.7l2-2l-1.4-1.4l-2,2
			c-0.5-1.1-0.3-2.5,0.6-3.4c0.2-0.2,0.7-0.5,1.5-0.8c0.7-0.3,1.6-0.5,2.5-0.6c0.7-0.1,1.4-0.3,2-0.3c-0.1,0.6-0.2,1.3-0.3,2
			c-0.2,0.9-0.4,1.7-0.6,2.5c-0.3,0.8-0.5,1.3-0.8,1.5C17.3,28,16,28.2,14.8,27.7z"/>
		<path class="st0" d="M14,6H6L5.3,0l-2,0.2L4,6H0l4.3,34H24l2.6-20.6c3.8-1.4,6.5-5.1,6.5-9.4c0-5.5-4.5-10-10-10
			C19,0,15.5,2.5,14,6z M16.2,6c1.4-2.4,4-4,6.9-4c4.4,0,8,3.6,8,8c0,3.1-1.7,5.7-4.3,7.1L28.3,6H16.2z M13.3,8
			c-0.1,0.6-0.2,1.3-0.2,2c0,0.7,0.1,1.4,0.2,2H6.8L6.3,8H13.3z M15.4,12c-0.2-0.6-0.3-1.3-0.3-2c0-0.7,0.1-1.4,0.3-2H26l-0.5,4
			H15.4z M2.3,8h2l0.5,4h-2L2.3,8z M3,14h2l3,24H6L3,14z M7,14h18.2l-2.8,22.5C21.6,35,20,34,18.1,34c-0.8,0-1.7,0.3-2.5,0.7
			c-0.8,0.4-1.7,0.9-2.4,1.4c-0.8,0.5-1.5,1-2,1.4c-0.2,0.2-0.4,0.3-0.5,0.4H10L7,14z M18.1,36c1.3,0,2.4,0.8,2.8,2h-6.9
			c0.1-0.1,0.2-0.1,0.3-0.2c0.7-0.5,1.5-1,2.2-1.3C17.3,36.2,17.8,36,18.1,36z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as CocktailMojito
};
